import React, { useState, useEffect } from 'react'
import './Encuentas.css'
import { useNavigate, Link } from 'react-router-dom'
import { MiFooter } from '../../components/footer/MiFooter'
import { useContext } from 'react'
import { UsuarioContext } from '../../contexts/UsuarioContext'
import { ContentBodyEncuestas } from '../../components/Encuestas/ContentBodyEncuestas'
import HeaderHome from '../../components/headerHome/HeaderHome'

export const Encuestas = () => {
  /* A hook that is used to change the state of the menu. */
  const [MenuLateral, setMenuLateral] = useContext(UsuarioContext);
  const closeMenu = () => {
    if (MenuLateral === true) {
      setMenuLateral(false);
    }
  }
  const navigate = useNavigate();
  const olvidarContraseña = () => {
    navigate('/recuperarContraseña');
  }
  //<div onClick={navegar}>Si no tiene cuenta, <b>regístrese aquí.</b></div>
  return (
    <div className='Encuesta' onClick={closeMenu}>
      <div className='headerEncuesta'> <HeaderHome /> </div>
      <div className='bodyEncuesta'>
        <ContentBodyEncuestas />
      <div className='footerEncuesta'> <MiFooter /> </div>
      </div>
    </div>
  )
}

export default Encuestas;
